import instance from 'config/interceptor';

export const getHistoryVersionApp = async () => {
  const { data } = await instance.get(`/VersiAplikasi/GetHistoryVersionApp`)
  return data;
};

export const updateHistoryVersionApp = async (params: any)=> {
  return await instance.put(`/VersiAplikasi/EditStatusVersionApp`, params)
}

export const addHistoryVersionApp = async (params: any)=> {
  return await instance.post(`/VersiAplikasi/AddNewVersionApp`, params)
}